import React from "react"
import styled from "@emotion/styled"
import Section from "src/components/Section"
import Grid from "src/components/Grid"
import { mq, colors, globals } from "src/styles"
import ScrollEntrance from "src/components/ScrollEntrance"
import ContactForm from "src/components/ContactForm"
import TextLockup from "src/components/TextLockup"

const Wrapper = styled(Section)`
  ${({ vertical }) =>
    `
    ${globals.verticalSpacing("padding-top", vertical)}
    ${globals.verticalSpacing("padding-bottom", vertical)}
    `}
  ${({ horizontal }) =>
    `
    ${globals.verticalSpacing("padding-left", horizontal)}
    ${globals.verticalSpacing("padding-right", horizontal)}
  `}
  ${mq.mediumAndBelow} {
    ${({ hideMobile }) => (hideMobile && "display: none")}
  }
  ${mq.largeAndUp} {
    ${({ hideDesktop }) => (hideDesktop && "display: none")}
  }
`

const FormCard = styled(ContactForm)`
  background: ${colors.white};
  box-shadow: ${globals.shadow()};
`

const ContactFormSection = ({
  className,
  nextTheme,
  prevTheme,
  theme,
  spacing,
  isFirstSection,
  introText,
  actions,
  headingSize,
  formHeadline,
  id,
  hideMobile,
  hideDesktop,
}) => {
  return (
    <Wrapper
      className={className}
      prevTheme={prevTheme}
      setTheme={theme}
      nextTheme={nextTheme}
      isFirstSection={isFirstSection}
      id={id}
      vertical={spacing?.vertical}
      horizontal={spacing?.horizontal}
      hideMobile={hideMobile}
      hideDesktop={hideDesktop}
    >
      <Grid
        small="m [1] m"
        medium="1 [12] 1"
        large="1 [5] 1 [6] 1"
        larger="1 [5] 1 [5] 2"
        rowGap="30px"
        vAlign="top"
        as={ScrollEntrance}
      >
        <div>
          <TextLockup
            eyebrow={introText?.eyebrow}
            newStyle={introText?.newStyle}
            text={introText?._rawText}
            alignment="left"
            actions={actions}
          />
        </div>
        <div>
          <FormCard inputTheme="lightGrey">
            {formHeadline && (
              <h4
                style={{
                  margin: "0 0 .75em 0",
                  maxWidth: "12.5em",
                  marginTop: "-.15em",
                }}
                className={headingSize ? headingSize : "h3"}
              >
                {formHeadline}
              </h4>
            )}
          </FormCard>
        </div>
      </Grid>
    </Wrapper>
  )
}

export default ContactFormSection
